export type AxiosMetaParams = {
  skipToaster?: boolean;
};

export const SKIP_TOASTER_PARAMS: AxiosMetaParams = {
  skipToaster: true,
};
